import React, { useContext, useEffect, Fragment } from 'react'
import LayoutView from './LayoutView'
import { withRouter } from 'react-router'
import { LayoutContext } from './LayoutContext'
import headerLogo from "./img/RoroLogoGreenTransparent150.png";

const defaultState = {
    pageTitle: "RoRo",
    closeable: false,
    menuVisible: false,
    menuEnabled: true,
    backgroundColor: "#fff",
    customClass: "normal-header",
    extra: []
}

class LayoutContainer extends React.Component {
    constructor(props) {
        super(props)
        this.state = defaultState
    }

    updateState = (nState) => {
        this.setState(nState)
    }

    onClose = () => {
        this.props.history.goBack()
    }

    openMenu = () => {
        this.setState({ menuVisible: true })
    }

    closeMenu = () => {
        this.setState({ menuVisible: false })
    }

    render() {
        const { children } = this.props;
        return <LayoutContext.Provider value={[this.state, this.updateState]} >
            <LayoutView closeable={this.state.closeable} onClose={this.onClose} customClassName={this.state.customClass}
                menuVisible={this.state.menuVisible} openMenu={this.openMenu} closeMenu={this.closeMenu}
                pageTitle={this.state.pageTitle} menuEnabled={this.state.menuEnabled}
                backgroundColor={this.state.backgroundColor} extra={this.state.extra}
            >{children}</LayoutView>
        </LayoutContext.Provider>
    }
}
export default withRouter(LayoutContainer)

export const useLayoutHeader = (conf) => {
    const [, setAppContext] = useContext(LayoutContext)

    useEffect(() => {
        setAppContext(conf)
        return () => { setAppContext(defaultState) }
    },
        // eslint-disable-next-line
        [])

}

export const LayoutHeaderConfig = ({
    closeable = false,
    menuEnabled = true,
    extra = [<img
        src={headerLogo}
        width="50%"
    />],
    pageTitle = "RoRo",
    backgroundColor = "#fff",
    customClass = "normal-header"
}) => {
    useLayoutHeader({
        closeable,
        pageTitle,
        menuEnabled,
        backgroundColor,
        customClass,
        extra,
    })
    return <Fragment />
}
